import type { ReactElement } from "react";
import type { UtilityInference } from "@shared/api";
import { serviceTitle } from "./utilityInferenceLabels";
import { UtilityConfidencePill } from "./UtilityConfidencePill";
import styles from "./UtilityInferenceRow.module.css";

function secondaryCopy(inference: UtilityInference): string {
  const r = inference.reason.trim();
  if (r.length > 0) return r;
  return inference.label.trim();
}

export interface UtilityInferenceRowProps {
  inference: UtilityInference;
}

export function UtilityInferenceRow({
  inference
}: UtilityInferenceRowProps): ReactElement {
  const detail = secondaryCopy(inference);

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <span className={styles.service} title={inference.label.trim() || undefined}>
          {serviceTitle(inference.service)}
        </span>
        <UtilityConfidencePill confidence={inference.confidence} />
      </div>
      {detail.length > 0 ? (
        <span className={styles.subtext}>{detail}</span>
      ) : null}
    </div>
  );
}
